<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Gestion des emplois et des parcours professionnels (GEPP)" subTitle=""
        srcImg="/images/pages/conseil-rh/desc-picture.png" backgroundSpan="span-background-blue-long" />
    </section>
    <section>
      <NavLeft tab="gepp" breadcrumb1=""
        breadcrumb2="Gestion des emplois et des parcours professionnels (GEPP)" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
  title: "EMCI - gestion des emplois et des parcours professionnels (GEPP)",
  meta: [
    {
      name: "description",
      content: "EMCI vous accompagne pour la mise en œuvre de la GEPP au sein de votre structure"
    }
  ]
})
</script>

<style scoped>
.body {
  
  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }
  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>